import { Box } from "@mui/material";
import Logo from "../shared/Logo";
import { getSymbolImageUrl } from "../../lib/symbolImage";

interface CompanyMarkProps {
  symbol: string;
  size?: number;
  /** Corner rounding; the mark is square so this is the only shape control. */
  radius?: string;
}

/**
 * A company logo, rendered as the provider ships it.
 *
 * This briefly carried a white plate behind the image so dark-ink transparent
 * logos (PCAR is pure black) stayed visible on the dark theme. That is gone
 * (Ben, 2026-07-31): the assumption behind it — that logos either ship an
 * opaque background or a transparent one — misses the common third case, a
 * logo whose own background is opaque but ROUNDED. AUR's is, and the plate
 * showed through its corners as four white notches on every source card and
 * activity line. Fixing the rare invisible logo made the common well-formed
 * logo look broken, which is the wrong trade.
 *
 * The residual problem (black-on-near-black marks) is the provider's artwork,
 * not something this component can solve without damaging everything else.
 *
 * The rounding stays: it clips the provider's own square edges to match the
 * radius the rest of the chat surfaces use.
 */
export const CompanyMark = ({
  symbol,
  size = 16,
  radius = "3px",
}: CompanyMarkProps) => (
  <Box
    sx={{
      display: "flex",
      flex: "none",
      borderRadius: radius,
      overflow: "hidden",
    }}
  >
    <Logo
      src={getSymbolImageUrl(symbol)}
      alt={symbol}
      ticker={symbol}
      size={size}
    />
  </Box>
);
